import { Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { CSVDownloadButton } from '@/components/CSVDownloadButton';
import { useGetAudienceProducts } from '@/hooks/useGetAudienceProducts';
import { Audience } from '@/services/AudiencesService';

interface ProductsInSetProps {
  audience: Pick<Audience, 'id' | 'name' | 'products_in_set_active'>;
}

export function ProductsInSet({ audience }: ProductsInSetProps) {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.Behaviors.AudiencesCreate.components.AudienceSliderControl',
  });
  const { audienceProducts, getAudienceProducts } = useGetAudienceProducts(
    audience.id,
  );

  const data =
    audienceProducts?.map((audienceProduct) => ({
      product_id: audienceProduct.product.productId,
    })) ?? [];

  const headers = [{ label: 'product_id', key: 'product_id' }];

  async function handleDownload() {
    await getAudienceProducts();
  }

  return (
    <div>
      <div className="flex flex-row justify-between gap-2">
        <p className="text-sm text-gray-600">{t('productsInSetLabel')}</p>
        <div className="text-w-10 flex flex-row items-center gap-2 font-semibold text-blue-600 hover:underline">
          {Number(audience.products_in_set_active)}
          <CSVDownloadButton
            data={data}
            headers={headers}
            onDownload={handleDownload}
          >
            <Download className="h-4 w-4" />
          </CSVDownloadButton>
        </div>
      </div>
    </div>
  );
}
